import React from "react";
import Message from "carbon-react/lib/components/message";

import "./Message.css";

const ErrorMessage = (props) => {
  const dismissVisible =
    props.onDismiss && typeof props.onDismiss === "function";

  return (
    <Message
      className="message-banner"
      as="error"
      border
      id={props.id || "errorMessageId"}
      open
      roundedCorners
      {...(dismissVisible
        ? {
            onDismiss: () => {
              props.onDismiss();
            },
          }
        : {})}
      {...(dismissVisible ? { showCloseIcon: true } : {})}
    >
      {props.message}
    </Message>
  );
};

export default ErrorMessage;
